module.exports = __webpack_public_path__ + "img/polygon-logo.eb794582.svg";